import { render, staticRenderFns } from "./LeadsIcon.vue?vue&type=template&id=febbfb58&scoped=true"
import script from "./LeadsIcon.vue?vue&type=script&lang=ts"
export * from "./LeadsIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febbfb58",
  null
  
)

export default component.exports